module.exports = __webpack_public_path__ + "img/right.dfab501f.svg";